import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenshotMonitorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screenshot_monitor"}/>
}
